import script from "./TournamentViewReadOnly.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentViewReadOnly.vue?vue&type=script&setup=true&lang=js"

import "./TournamentViewReadOnly.vue?vue&type=style&index=0&id=558d536a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../Users/kmg/Documents/VS Code/Classwork/poker-session-tracker-vue3/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558d536a"]])

export default __exports__